import './InfoPopup.css'

function InfoPopup({ title = 'Căn Hộ 10', type = '1PN - 1WC', specs = [] }) {
  return (
    <div className="info-popup">
      <div className="info-popup__inner">
        <div className="info-popup__header">
          <h3 className="info-popup__title">{title}</h3>
          <h4 className="info-popup__subtitle">{type}</h4>
        </div>
        <div className="info-popup__body">
          {specs.map((spec, index) => (
            <div key={index} className="info-popup__row">
              <span className="info-popup__label">{spec.label}:</span>
              <span className="info-popup__value">{spec.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default InfoPopup
